import Vue from 'vue';
import VueGtm from 'vue-gtm';
import router from '../router';
import config from '../config';

// AnalyticsService is an adapter for VueGtm, but we still want
// to register VueGtm with Vue because it will automatically
// track page views for us based on the router settings.
Vue.use(VueGtm, {
  id: 'GTM-KSBTP6H',
  enabled: config.Node === 'production',
  // enabled: true,
  debug: config.Node !== 'production',
  vueRouter: router,
  ignoredViews: [],
});

export default class AnalyticsService {
  constructor(gtm) {
    this.gtm = gtm;
    this.pwrlabCost = 15.99;
  }

  trackRegistration(memberId, coupon) {
    let type = 'trial';
    if (typeof coupon === 'string' && coupon.length > 0) {
      type = 'coupon';
    }

    this._doTrackEvent(type, memberId, 0);
  }

  trackPurchase(memberId) {
    this._doTrackEvent('purchase', memberId, this.pwrlabCost);
  }

  _doTrackEvent(type, memberId, cost) {
    const name = `PWR Lab - ${type}`;
    this.gtm.trackEvent({
      transactionId: `${type}-${memberId}`,
      transactionTotal: cost,
      transactionProducts: [{
        name,
        sku: name,
        price: cost,
        quantity: 1,
      }],
      event: 'purchaseMade',
    });
  }
}
